import { render, staticRenderFns } from "./webapp.vue?vue&type=template&id=56896c69&scoped=true"
import script from "./webapp.vue?vue&type=script&lang=js"
export * from "./webapp.vue?vue&type=script&lang=js"
import style0 from "./webapp.vue?vue&type=style&index=0&id=56896c69&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56896c69",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56896c69')) {
      api.createRecord('56896c69', component.options)
    } else {
      api.reload('56896c69', component.options)
    }
    module.hot.accept("./webapp.vue?vue&type=template&id=56896c69&scoped=true", function () {
      api.rerender('56896c69', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/homeHead/webapp.vue"
export default component.exports